import FeedbackRepository from './repositories/feedback.repository';

class FeedbackService {
  constructor() {
    this.repository = new FeedbackRepository();
  }

  /**
   * Submit feedback
   * @param {FormData} formData - Form data containing:
   *   - type: string (bug, improvement, review, other)
   *   - description: string (max 1000 chars)
   *   - email: string (optional)
   *   - attachment: File (optional)
   * @returns {Promise} API response
   */
  async submit(formData) {
    return this.repository.submit(formData);
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
